import React from 'react';

function getDesign(messageListLogin) {

    return (
        <div>
          <p className="ds-text">
            {messageListLogin.M027_parther001}<br />
            {messageListLogin.M028_parther002}<br />
            {messageListLogin.M029_parther003}
          </p>
          <div className="textLinkList textLinkList--landscape">
            <a href={messageListLogin.M069_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
              {messageListLogin.M030_parther004}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
            <a href={messageListLogin.M070_noticeUrl002} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
              {messageListLogin.M031_parther005}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
          </div>
          <p className="ds-text">{messageListLogin.M032_parther006}</p>
          <a href={messageListLogin.M071_noticeUrl003} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
            {messageListLogin.M033_parther007}&nbsp;
            <span className="ds-textLink__icon">
              <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
              </svg>
            </span>
          </a>
        </div>
    );
}

export {getDesign}
